/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
import { NETPOSITION, NET_POSITION_INFO } from "../actionTypes";
import { netPosition, positionConversion, squareOffAllOrders } from "../../apis";
import { getMktSegIdFromApiExchangeName, getExchangeName, getGroupedSegement, getMappedMktSegIdFromApiExchangeName, getDecryptLocalStorage, handleMTFPledgeRequest, getAppInfoData } from "../../utils/global_functions";
import { _getProductType, _getScripsInfo } from "../../controllers";
import { APP_INFO_PARAMS, LOCAL_STORAGE_KEYS, NET_POSITION_EXPIRY, ORDER_ENTRY_TYPES } from "../../utils/global_variables";

export const getNetPositions = (strPayload, isEnabled = false) => async (dispatch, getState) => {
    // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – Start 
    dispatch(netPositionApiPending(true));
    // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – End 
    try {
        const objResp = await netPosition(strPayload);
        const productTypeData = getState()?.orders?.productTypes;
        const objLoginSession = getState()?.auth?.objLoginSession;
        const netPositionRowData = objResp?.data?.data?.map((element, i) => (
            {
                id: getMktSegIdFromApiExchangeName(isEnabled ? element.exchange : element.preferred_exchange) + '_' + (isEnabled ? element.scrip_token : element.preferred_scrip_token) + '_' + _getProductType(element.product_type, element.preferred_exchange, productTypeData, objLoginSession),
                net_position_detail: '',
                title: element.symbol,
                net_quantity: Number(element.net_quantity),
                avg_buy_price: (element.avg_buy_price === '0.00' ? element.cf_net_price : element.avg_buy_price),
                ltp: 0.00,
                total_profit_loss: 0.00,
                profit_loss: 0.00,
                series: element.series,
                product_type: _getProductType(element.product_type, element.preferred_exchange, productTypeData, objLoginSession),
                // Azeem K : 19-12-2023 :BT-102298 : NSEEQ Netposition  ---Start 
                api_product_type: element?.product_type,
                // Azeem K : 19-12-2023 :BT-102298 : NSEEQ Netposition  ---End 
                net_value: element.net_value,
                buy_quantity: element.buy_quantity,
                buy_value: element.buy_value,
                sell_quantity: element.sell_quantity,
                avg_sell_price: element.avg_sell_price,
                expiry_date: element.expiry_date,
                ltpPercentChange: 0.00,
                sell_value: element.sell_value,
                // Azeem K : 20-03-2024 :BT-102298 : BSEFO Netposition  ---Start 
                net_price: parseFloat(element.cf_net_price) === 0 ? element.net_price : element.cf_net_price,//element.net_price
                // Azeem K : 20-03-2024 :BT-102298 : BSEFO Netposition  ---End 
                scrip_token: (isEnabled ? element.scrip_token : element.preferred_scrip_token),
                preferred_exchange: (isEnabled ? element.exchange : element.preferred_exchange),
                preferred_scrip_token: element.preferred_scrip_token,
                daily_or_expiry: element.daily_or_expiry,
                segment_id_token: getMktSegIdFromApiExchangeName(isEnabled ? element.exchange : element.preferred_exchange) + '_' + (isEnabled ? element.scrip_token : element.preferred_scrip_token),
                realised_pl: 0.00,
                unrealised_pl: 0.00,
                todays_pl: 0.00,
                overAll_pl: 0.00,
                close_price: 0.00,
                bid_price: 0.00,
                ask_price: 0.00,
                range: 0.00,
                cmv: 0.00,
                slTrigger: 0.00,
                lastTradePrice: 0.00,
                cf_buy_value: element.cf_buy_value,
                cf_net_price: element.cf_net_price,
                cf_sell_value: element.cf_sell_value,
                market_lot: element.market_lot,
                price_den: element.price_den,
                price_num: element.price_num,
                gen_den: element.gen_den,
                gen_num: element.gen_num,
                reference_rate: element.reference_rate,
                instrument: element.instrument,
                exchange: element.exchange,
                strike_price: element.strike_price,
                option_type: element.option_type,
                modified_quantity: Number(element.net_quantity),
                order_type: ORDER_ENTRY_TYPES.RL_MKT,
                validity: (element.exchange.includes('BSE_EQ') ? 'EOSESS' : "DAY"),
                market_type: 'Market',
                unsetteled_quantity: element.unsetteled_quantity,
                preferred_mktSegId: getMktSegIdFromApiExchangeName(element.preferred_exchange),
                displayExchange: getExchangeName(getMktSegIdFromApiExchangeName(element.exchange)),
                customSegment: getGroupedSegement(getExchangeName(getMktSegIdFromApiExchangeName(element.exchange)), element.instrument.trim()),
            }
        ));


        const arrUniqueScrips = [];
        const seenCombination = {};
        objResp?.data?.data?.forEach(element => {
            // Azeem K : 13-02-2024 : BT-102298 NSE EQ Netposition –--Start

            let segmentAndToken = `${getMktSegIdFromApiExchangeName(element?.preferred_exchange)}-${element?.preferred_scrip_token}`;
            if (strPayload?.interopFlag === 0) {

                segmentAndToken = `${getMktSegIdFromApiExchangeName(element?.exchange)}-${element?.scrip_token}`;
            } else {
                segmentAndToken = `${getMktSegIdFromApiExchangeName(element?.preferred_exchange)}-${element?.preferred_scrip_token}`;

            }
            // Azeem K : 13-02-2024 : BT-102298 NSE EQ Netposition –--End

            if (!seenCombination[segmentAndToken]) {
                seenCombination[segmentAndToken] = true;
                // Azeem K : 13-02-2024 : BT-102298 NSE EQ Netposition –--Start
                if (strPayload?.interopFlag === 0) {

                    arrUniqueScrips.push({ mkt: element?.exchange, token: element.scrip_token });
                } else {
                    arrUniqueScrips.push({ mkt: element?.preferred_exchange, token: element.preferred_scrip_token });
                }
                // Azeem K : 13-02-2024 : BT-102298 NSE EQ Netposition –--End
            }
        });
        let objScripsResp = await _getScripsInfo(arrUniqueScrips);
        let updatedResp = netPositionRowData;
        if (objResp?.status) {
            updatedResp?.forEach((eachResp, i) => {
                const updatedObjScripsResp = objScripsResp?.data?.objScripsResp?.result;
                // Azeem K : 13-02-2024 : BT-102298 NSE EQ Netposition –--Start
                let nIndex = -1;
                if (strPayload?.interopFlag === 0) {
                    nIndex = updatedObjScripsResp?.findIndex((eachScrip) => (getMappedMktSegIdFromApiExchangeName(eachResp?.exchange) + '-' + eachResp?.scrip_token === eachScrip?.id));
                } else {

                    nIndex = updatedObjScripsResp?.findIndex((eachScrip) => (getMappedMktSegIdFromApiExchangeName(eachResp?.preferred_exchange) + '-' + eachResp?.preferred_scrip_token === eachScrip?.id));
                }
                // Azeem K : 13-02-2024 : BT-102298 NSE EQ Netposition –--End
                if (nIndex >= 0) {
                    updatedResp[i].ScripData = [updatedObjScripsResp[nIndex]];
                } else { }
            });
        }
        else { }


        let netPositionTodays = [];
        let netPositionOverall = [];
        // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – Start 
        const objTodaysPositionIndexses = {};
        const objOverAllArrayIndexes = {};
        if (updatedResp?.length > 0) {
            updatedResp.forEach((each) => {
                if (each?.daily_or_expiry === NET_POSITION_EXPIRY.EXPIRY) {
                    netPositionOverall?.push(each);
                    if (!objOverAllArrayIndexes[each.segment_id_token]) {
                        objOverAllArrayIndexes[each.segment_id_token] = [];
                    } else { }
                    objOverAllArrayIndexes[each.segment_id_token].push(netPositionOverall.length - 1);
                }
                else if (each?.daily_or_expiry === NET_POSITION_EXPIRY.DAILY) {
                    // let nINdex = netPositionTodays?.findIndex((eachScrip) => (eachScrip?.id === each?.id));
                    // if (nINdex < 0) {
                    netPositionTodays?.push(each);
                    if (!objTodaysPositionIndexses[each.segment_id_token]) {
                        objTodaysPositionIndexses[each.segment_id_token] = [];
                    } else { }
                    objTodaysPositionIndexses[each.segment_id_token].push(netPositionTodays.length - 1);
                    // } else { }
                }

            });
            if (strPayload?.interopFlag === 0) {
                dispatch(updateInteropOffOverall(netPositionOverall));
                dispatch(updateInteropOffTodays(netPositionTodays));
            } else {
                dispatch(updateOverallPostions(netPositionOverall));
                dispatch(updateTodaysPositions(netPositionTodays));
                dispatch(updateObjTodaysPositionsIndexes(objTodaysPositionIndexses));
                dispatch(updateObjOverAllPositionsIndexes(objOverAllArrayIndexes));
            }
            netPositionTodays = [];
            netPositionOverall = [];
        } else { }

    } catch (error) {
        console.log(error);
        dispatch(updateTodaysPositions([]));
    } finally {
        dispatch(netPositionApiPending(false));
    }
    // Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – End 
};


export const updateNetPositionColdef = (payload) => {
    return { type: NET_POSITION_INFO?.UPDATE_NETPOSITION_COL_DEF, payload };
};


export const updateOverallPostions = (payload) => {
    return { type: NET_POSITION_INFO.UPDATE_OVERALL_POSITIONS, payload };
};


export const updateTodaysPositions = (payload) => {
    return { type: NET_POSITION_INFO.UPDATE_TODAYS_POSITIONS, payload };
};
// Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – Start 
export const updateObjTodaysPositionsIndexes = (payload) => {
    return { type: NET_POSITION_INFO.UPDATE_TODAYS_POSITIONS_INDEXES, payload };
};
export const updateObjOverAllPositionsIndexes = (payload) => {
    return { type: NET_POSITION_INFO.UPDATE_OVERALL_POSITIONS_INDEXES, payload };
};
export const netPositionApiPending = (payload) => {
    return { type: NET_POSITION_INFO.NET_POSITION_API_PENDING, payload };
};
// Azeem K : 22-02-2024 : BT-102298   Net Positions Optamization – End 

export const updateInteropOffOverall = (payload) => {
    return { type: NET_POSITION_INFO.UPDATE_INTEROP_OVERALL_POSITIONS, payload };
};

export const updateInteropOffTodays = (payload) => {
    return { type: NET_POSITION_INFO.UPDATE_INTEROP_TODAYS_POSITIONS, payload };
};


export const updateActiveNetPositions = (active) => {
    return { type: NETPOSITION.UPDATE_ACTIVE_NET_POSITION, payload: active };
};


export const updateTodaysPandL = (payload) => {
    return { type: NETPOSITION.UPDATE_TODAY_PL, payload };
};

export const updateOverallPandL = (payload) => {
    return { type: NETPOSITION.UPDATE_OVERALL_PL, payload };
};

export const updateIsSquareOff = (payload) => {
    return { type: NETPOSITION.UPDATE_IS_SQUARE_OFF, payload };
};

export const convertPosition = (exchangeType = '', scripToken = '', transactionType = '', quantity = '', oldProductType = '', newProductType = '', appInfo, userId, objLoginSession, scripOrderInfo) => async (dispatch,getState) => {
    dispatch(convertOrSquareOffPositionApiPending(true));
    
    try {
        const objCFT = getState()?.auth?.objCFT;

        const payload = {
            exchange: exchangeType,
            scrip_token: scripToken,
            transaction_type: transactionType,
            quantity: quantity,
            old_product_type: oldProductType?.toUpperCase(),
            new_product_type: newProductType?.toUpperCase(),
            bo_order_id: "",
        };
        if (newProductType?.toUpperCase() === 'MTF' && transactionType === 'BUY' && objCFT?.PLEDGEUNPLEDGE && getAppInfoData(APP_INFO_PARAMS.APP_MTF_PREPLEDGE, appInfo)) {
            const result = await handleMTFPledgeRequest(quantity, appInfo, userId, objLoginSession, scripOrderInfo[0]);
            if (result) {
                const objResp = await positionConversion(payload);
                dispatch(convertPositionSuccess(objResp?.data));
                return objResp;
            } else {
                throw new Error("Pledge request failed or returned false");
            }
        } else {
            const objResp = await positionConversion(payload);
            dispatch(convertPositionSuccess(objResp?.data));
            return objResp;
        }
    } catch (error) {
        if (error?.response?.data) {
            dispatch(convertPositionFailure(error.response.data));
        } else {
            dispatch(convertPositionFailure({}));
        }
        return Promise.reject(error);
    } finally {
        dispatch(convertOrSquareOffPositionApiPending(false));
    }
};


export const convertPositionSuccess = (payload) => {
    return { type: NETPOSITION.CONVERT_POSITION_SUCCESS, payload };
};

export const convertPositionFailure = (payload) => {
    return { type: NETPOSITION.CONVERT_POSITION_FAILURE, payload };
};

export const squareOffPosition = (requestArray) => async (dispatch) => {
    dispatch(convertOrSquareOffPositionApiPending(true));
    try {

        const arrPayload = requestArray?.map((order) => ({ ...order, deviceinfo: JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.DEVICE_INFO)) }));//Azeem K :30-05-2024 : added device info for each object
        // let requestArray = [];
        // newData.forEach(element => {
        //     requestArray.push({
        //         "scrip_info": {
        //             "exchange": element.preferred_exchange,
        //             "scrip_token": element.preferred_scrip_token,
        //             "symbol": element.title,
        //             "series": element.series,
        //             "expiry_date": element.expiry_date,
        //             "strike_price": element.strike_price,
        //             "option_type": element.option_type
        //         },
        //         "transaction_type": element.net_quantity > 0 ? 'SELL' : 'BUY',
        //         "product_type": element.product_type,
        //         "order_type": 'RL-MKT',
        //         "quantity": Math.abs(element.net_quantity),
        //         "price": element.ltp,
        //         "trigger_price": parseFloat(element?.slTrigger) ? parseFloat(element?.slTrigger) : 0,
        //         "disclosed_quantity": 0,
        //         "validity": element?.validity,
        //         "is_amo": false,
        //         "order_identifier": ''
        //     });
        // });
        const objResp = await squareOffAllOrders(arrPayload);
        dispatch(squareOffPositionSuccess(objResp?.data));
        return Promise.resolve(objResp?.data);
    } catch (error) {
        console.log(error.message);
        if (error?.response?.data) {
            dispatch(squareOffPositionFailure(error.response.data));
        } else {
            dispatch(squareOffPositionFailure({}));
        }
        return Promise.reject(error);
    } finally {
        dispatch(convertOrSquareOffPositionApiPending(false));

    }
};

export const squareOffPositionSuccess = (payload) => {
    return { type: NETPOSITION.SQUAREOFF_POSITION_SUCCESS, payload };
};

export const squareOffPositionFailure = (payload) => {
    return { type: NETPOSITION.SQUAREOFF_POSITION_FAILURE, payload };
};

// {/* Mahesh S : 09-11-2023 : BT-102298 NSECDS Netposition – netposition column def changes – Start */ }
export const getNetPositionColumnDefs = () => async (dispatch) => {
    try {
        // Mahesh S : 28-11-2023 : BT-102298 NSECDS Netposition – netposition coldef changes - start
        const objResp = [
            { field: 'title', headerName: "SCRIP NAME" },
            { field: 'net_quantity', headerName: 'NET QTY', filter: 'agNumberColumnFilter' },
            { field: 'total_profit_loss', headerName: "TODAY'S P/L", filter: 'agNumberColumnFilter', },
            { field: 'ltp', headerName: "LTP", filter: 'agNumberColumnFilter' },
            { field: 'buy_quantity', headerName: 'BUY QTY', filter: 'agNumberColumnFilter' },
            { field: 'avg_buy_price', headerName: 'BUY AVG PRICE', filter: 'agNumberColumnFilter' },
            { field: 'buy_value', headerName: 'BUY VALUE', filter: 'agNumberColumnFilter' },
            { field: 'sell_quantity', headerName: 'SELL QTY', filter: 'agNumberColumnFilter' },
            { field: 'avg_sell_price', headerName: 'SELL AVG PRICE', filter: 'agNumberColumnFilter' },
            { field: 'sell_value', headerName: 'SELL VALUE', filter: 'agNumberColumnFilter' },
            { field: 'net_price', headerName: "NET AVG PRICE", filter: 'agNumberColumnFilter' },
            { field: 'net_value', headerName: 'NET VALUE', filter: 'agNumberColumnFilter' },
            { field: 'profit_loss', headerName: "ACTUAL P/L", filter: 'agNumberColumnFilter' },
            { field: 'product_type', headerName: "PRODUCT TYPE", filter: 'agSetColumnFilter' },
        ];
        // Mahesh S : 28-11-2023 : BT-102298 NSECDS Netposition – netposition coldef changes - end
        dispatch(getNetPositionColumnDefsSuccess(objResp));
    } catch (error) {
        dispatch(getNetPositionColumnDefsFailure([]));

    }
};
export const getNetPositionColumnDefsSuccess = (payload) => {
    return { type: NETPOSITION.GET_NETPOSITION_COLUMNDEF_SUCCESS, payload };

};
export const getNetPositionColumnDefsFailure = (payload) => {
    return { type: NETPOSITION.GET_NETPOSITION_COLUMNDEF_FAILURE, payload: payload };

};
// {/* Mahesh S : 09-11-2023 : BT-102298 NSECDS Netposition – netposition column def changes – End */ }

export const convertOrSquareOffPositionApiPending = (payload) => {
    return { type: NETPOSITION.CONVERT_OR_SQUAREOFF_POSITION_API_PENDING, payload };
};
